export enum ReturnShippingMethodType {
  ReturnLabel = 1,
  ReturnOwn = 2,
  ReturnGreen = 3,
  ReturnPickup = 4,
}

export const RETURN_SHIPPING_METHOD_LIST = [
  ReturnShippingMethodType.ReturnLabel,
  ReturnShippingMethodType.ReturnPickup,
  ReturnShippingMethodType.ReturnOwn,
  ReturnShippingMethodType.ReturnGreen,
]

export enum ReturnSolutionEnum {
  RefundToOriginalPaymentMethod = "1",
  RefundToStoreDiscount = "2",
  VariantExchange = "3",
  RefundToStoreGiftCard = "4",
  ExchangeForDifferentItems = "5",
  RefundViaWise = "6",
  RefundToStoreCredit = "7",
  RefundViaBankTransfer = "8",
}

export enum BankTransferInfoEnum {
  AccountNumber = 1,
  AccountHolderName = 2,
  BankIdentifier = 3,
}

export const RETURN_SHIPPING_METHOD_MAP = () => ({
  1: {
    label: t("MerchantLabel-0"),
    value: "1",
    desc: t("YouCreateOrUploadALabel"),
  },
  4: {
    label: t("Pickup"),
    value: "4",
    desc: t("ArrangePickupFromCustomer"),
  },
  3: {
    label: t("GreenReturn"),
    value: "3",
    desc: t("CustomerKeepsTheItem"),
  },
  2: {
    label: t("ShipOnYourOwn"),
    value: "2",
    desc: t("CustomerArrangesShipping"),
  },
})

export const RETURN_SOLUTION_MAP = () => ({
  1: {
    label: t("RefundToOriginalPaymentMethod"),
    customLabel: t("RefundToOriginalPaymentMethod"),
    value: ReturnSolutionEnum.RefundToOriginalPaymentMethod,
    desc: t("ProvideHassleFreeRefundsToOriginal"),
  },
  2: {
    label: t("RefundToStoreDiscount"),
    customLabel: t("RefundToStoreDiscount"),
    value: ReturnSolutionEnum.RefundToStoreDiscount,
    desc: t("EnhanceCustomerLoyaltyByOfferingSto"),
  },
  3: {
    label: t("ReplaceItem"),
    customLabel: t("ReplaceItem"),
    value: ReturnSolutionEnum.VariantExchange,
    desc: t("PriceDifferencesDoNotApplyEvenIfP"),
  },
  4: {
    label: t("RefundToStoreGiftCard"),
    customLabel: t("RefundToStoreGiftCard"),
    value: ReturnSolutionEnum.RefundToStoreGiftCard,
    desc: t("EnhanceCustomerLoyaltyByOfferingStoByGiftCard"),
  },
  5: {
    label: t("ExchangeItem"),
    customLabel: t("ExchangeItem"),
    value: ReturnSolutionEnum.ExchangeForDifferentItems,
    desc: t("PriceDifferencesWillBeChargedOrRef"),
  },
  6: {
    label: t("CustomReturnSolution"),
    desc: t("RefundForOrdersNotPaidThroughShopi"),
    customLabel: t("RefundViaWise"),
    value: ReturnSolutionEnum.RefundViaWise,
  },
  7: {
    label: t("RefundToStoreCredit"),
    customLabel: t("RefundToStoreCredit"),
    desc: t("OfferSeamlessRefundsAsStoreCreditB"),
    value: ReturnSolutionEnum.RefundToStoreCredit,
  },
  8: {
    label: t("RefundViaManualBankTransfer"),
    desc: t("RecordRefundForOrdersNotPaidThroug"),
    customLabel: t("RefundViaManualBankTransfer"),
    value: ReturnSolutionEnum.RefundViaBankTransfer,
  },
})

export const SOLUTION_LIST = () => {
  return Object.values(RETURN_SOLUTION_MAP()).map((item) => {
    return {
      label: item.customLabel || item.label,
      value: item.value,
    }
  })
}

export const METHOD_LIST = () => {
  return Object.values(RETURN_SHIPPING_METHOD_MAP()).map((item) => {
    return {
      label: item.label,
      value: item.value,
    }
  })
}

export const RETURN_SHIPMENT_STATUS_MAP = () => ({
  1: {
    label: t("Pending"),
    value: "1",
  },
  2: {
    label: t("InfoReceived"),
    value: "2",
  },
  3: {
    label: t("InTransit"),
    value: "3",
  },
  4: {
    label: t("OutForDelivery"),
    value: "4",
  },
  5: {
    label: t("Delivered"),
    value: "5",
  },
  7: {
    label: t("FailedAttempt"),
    value: "7",
  },
  8: {
    label: t("Expired"),
    value: "8",
  },
})

export const DAY_OPTIONS = () => [
  { label: t("Today"), value: "1" },
  { label: t("Last_7Days"), value: "7" },
  { label: t("Last_30Days"), value: "30" },
  { label: t("Last_60Days"), value: "60" },
  { label: t("Last_90Days"), value: "90" },
  { label: t("Last_365Days"), value: "365" },
  { label: t("Custom"), value: "custom" },
]

export const DAY_OPTIONS_MAP = () => {
  return DAY_OPTIONS().reduce((acc, item) => {
    acc[item.value] = item.label
    return acc
  }, {})
}
